export default __webpack_public_path__ + "static/media/aviary.14318861.png";